import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';
// import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import PowerIcon from '@material-ui/icons/Power';
import PropTypes from 'prop-types';
import React from 'react';

const TotalDownloads = React.memo(({ totalDownloads,year,rz, ...rest }) => {

  return  (
  <Card
    sx={{ height: '100%' }}
    {...rest}
  > 
    <CardContent>
      <Grid
        container
        spacing={3}
        sx={{ justifyContent: 'space-between' }}
      >
        <Grid item>
        <Typography
            color="#4a4a4a"
            gutterBottom
            variant="h6"
          >
           Alle RZs
          </Typography>
          
          <Typography
            color="#4a4a4a"
            variant="h3"
          >
            {new Intl.NumberFormat("de-DE").format(totalDownloads)} kWh
          </Typography>
          <Typography
            color="#4a4a4a"
            gutterBottom
            variant="h6"
          >
            GESAMTVERBRAUCH IT {year}
          </Typography>
          
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: '#1b66b3',
              color: '#fce531',
              height: 56,
              width: 56
            }}
          >
            <PowerIcon />
          </Avatar>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);
})

TotalDownloads.propTypes = {
  totalDownloads: PropTypes.any
};


export default TotalDownloads;
